import React from 'react'

const Footer = () => {
  return (
   <footer>
    <div><h1>AKSTech</h1>
    <p>@All Right Reserved</p></div>

    <div>
        <h5>Follow Us</h5>
        <div>
            <a href="https://www.youtube.com/"target="_blank">Youtube</a>
            <a href="https://www.instagram.com/"target={"blank"}>Instagram</a>
            <a href="https://github.com/"target={"blank"}>Github</a>
            
        </div>
    </div>
    

   </footer>
  )
}

export default Footer